<template>
  <BaseDialog :value="true" max-width="700" persistent>
    <template #modal>
      <BaseCosmoCard>
        <template #title>
          <div class="modal_header">
            <BaseTitle
              class="modal_header_title"
              v-text="$t('folder.yousign.relaunchMessage')"
            />
            <BaseButtonIcon icon="$mdiClose" @click="close()" />
          </div>
        </template>
        <div class="modal_content">
          <BaseMarkdownEditor
            v-model="message"
            :label="$t('folder.yousign.relaunchMessage')"
          />
        </div>

        <div class="modal_footer">
          <BaseButton color="grey" type="secondary" @click="close()">
            {{ $t("utils.cancel") }}
          </BaseButton>
          <BaseButton
            :loading="isSubmiting"
            :disabled="isSubmiting"
            @click="relaunchFolder()"
          >
            {{ $t("utils.validate") }}
          </BaseButton>
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>

<script>
import FolderAPI from "@/modules/Folder/Services/folder.api";
export default {
  name: "FolderRelaunchDialog",
  data() {
    return {
      isSubmiting: false,
      message: "",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async relaunchFolder() {
      this.isSubmiting = true;
      try {
        await FolderAPI.postFolderRemind({
          organizationId: this.$route.params.organizationId,
          folderId: this.$route.params.folderId,
          payload: {
            message: this.message,
          },
        });
        this.$emit("relaunch");
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.folder_relaunched_successfully"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 16px;
  flex-wrap: wrap;
  .modal_header_title {
    flex: 1;
  }
}
.modal_content {
  padding: 24px 10px;

  & > * {
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .label-input {
    font-size: 12px;
  }
  .descriptor {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #353542;
  }
}
.modal_footer {
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & > * {
    margin-left: 16px;
  }
}
</style>
